// extracted by mini-css-extract-plugin
export var dropdown = "_ua-0";
export var imageWrapper = "_ua-3";
export var itemNameContainer = "_ua-1";
export var productImage = "_ua-2";
export var spinnerWrapper = "_ua-4";